import { CommonActionTypes } from "./common.types";
import { IArray } from "../../models";
import { axiosClient } from "../../utils/axios-config";
import { dataConstants } from "../../constants/data-constants";
import { reduceArray } from "../../utils/utility-functions";

export const setLoading = (status: boolean): any => {
  return {
    type: CommonActionTypes.SET_LOADING,
    payload: status,
  };
};

export const setActiveTab = (id: number): any => {
  return {
    type: CommonActionTypes.SET_ACTIVE_TAB,
    payload: id,
  };
};

export const setSuccessMsg = (message: string): any => {
  return {
    type: CommonActionTypes.SET_SUCCESS,
    payload: message,
  };
};

export const setErrorMsg = (message: string): any => {
  return {
    type: CommonActionTypes.SET_ERROR,
    payload: message,
  };
};

export const setBranches = (branches: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_BRANCHES,
    payload: branches,
  };
};
export const setSeason = (season: Array<any>): any => {
  return {
    type: CommonActionTypes.SET_SEASON,
    payload: season,
  };
};

export const setHubs = (hubs: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_HUBS,
    payload: hubs,
  };
};

export const setVarieties = (varieties: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_VARIETIES,
    payload: varieties,
  };
};

export const setBagTypeList = (bagTypeList: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_BAG_TYPE_LIST,
    payload: bagTypeList,
  };
};

export const setCrops = (crops: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_CROPS,
    payload: crops,
  };
};
export const setDelivery = (delivery: string): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_DELIVERY,
    payload: delivery,
  };
};
export const setPo = (po: string): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_PO,
    payload: po,
  };
};
export const setPayment = (payment: string): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_PAYMENT,
    payload: payment,
  };
};
export const setSaudha = (saudha: string): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_SAUDHA,
    payload: saudha,
  };
};
export const setAuctionType = (type: string): any => {
  return {
    type: CommonActionTypes.SET_AUCTION_TYPE,
    payload: type,
  };
};

export const setCropsUnit = (cropsUnit: Array<IArray>): any => {
  return {
    type: CommonActionTypes.SET_CROPS_UNIT,
    payload: cropsUnit,
  };
};

export const setSelectedCrop = (cropId: number): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_CROP,
    payload: cropId,
  };
};

export const setSelectedBranch = (branchId: number): any => {
  return {
    type: CommonActionTypes.SET_SELECTED_BRANCH,
    payload: branchId,
  };
};

export const setInitialDataLoaded = (status: boolean): any => {
  return {
    type: CommonActionTypes.SET_INITIAL_DATA_LOADED,
    payload: status,
  };
};

export const setTC = (htmlText: string): any => {
  return {
    type: CommonActionTypes.SET_TC,
    payload: htmlText,
  };
};

export const setPoNumber = (poNumber: string): any => {
  return {
    type: CommonActionTypes.SET_PO_NUMBER,
    payload: poNumber,
  };
};

export const setVendor = (vendor: string): any => {
  return {
    type: CommonActionTypes.SET_VENDOR,
    payload: vendor,
  };
};

export const setPrivacyPolicy = (htmlText: string): any => {
  return {
    type: CommonActionTypes.SET_PRIVACY,
    payload: htmlText,
  };
};

export const setSuppliersBidsData = (BidsData: any): any => {
  return {
    type: CommonActionTypes.SET_SUPPLIER_BIDS,
    payload: BidsData,
  };
};
export const setAuctionBidData = (content: any): any => {
  return {
    type: CommonActionTypes.SET_AUCTION_BID,
    payload: content,
  };
};
export const setParameters = (parameters: any): any => {
  return {
    type: CommonActionTypes.SET_PARAMETERS,
    payload: parameters,
  };
};
export const resetCommonReducer = (): any => {
  return {
    type: CommonActionTypes.RESET_REDUCER,
  };
};

export const fetchPrivacyPolicy = (msg: boolean = true): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.getPrivacyPolicyUrl)
        .then((response) => {
          // dispatch(setPrivacyPolicy(response.data.data));
          dispatch(setLoading(false));
          return resolve(response.data.data);
          /* msg &&
          dispatch(
            setSuccessMsg("Updated privacy policy fetched successfully!")
          ); */
        })
        .catch((error) => {
          // dispatch(setLoading(false));
          // dispatch(setErrorMsg("Latest privacy policy not updated."));
        });
    });
  };
};

export const fetchTermsCondition = (msg: boolean = true): any => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.getTCUrl)
        .then((response) => {
          // dispatch(setTC(response.data.data));
          dispatch(setLoading(false));
          return resolve(response.data.data);
          /* msg &&
          dispatch(
            setSuccessMsg("Updated terms and conditions fetched successfully!")
          ); */
        })
        .catch((error) => {
          // dispatch(setLoading(false));
          // dispatch(setErrorMsg("Latest terms and conditions not updated."));
        });
    });
  };
};

export const fetchVarieties = (cropId: number, branchId: number): any => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    await axiosClient
      .post(dataConstants.getVarietiesUrl, {
        crop_id: cropId,
        branch_id: branchId,
      })
      .then((response) => {
        const modifiedVarietiesArray: { id: number; name: string }[] =
          reduceArray("variety_id", "variety_name", response.data.data);
        dispatch(setVarieties(modifiedVarietiesArray));
        dispatch(setLoading(false));
      })
      .catch((error) => {
        dispatch(setLoading(false));
        return dispatch(setErrorMsg("Latest varieties could not be updated."));
      });
  };
};

export const fetchBagType = (): any => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    await axiosClient
      .post(dataConstants.getBagTypeListUrl)
      .then((response) => {
        const modifiedArray: { id: number; name: string }[] = reduceArray(
          "parameter_data_value",
          "parameter_display_value",
          response.data.data
        );
        dispatch(setBagTypeList(modifiedArray));
        dispatch(setLoading(false));
      })
      .catch((error) => {
        dispatch(setLoading(false));
      });
  };
};

export const fetchBranchCropVarieties = (type: boolean = false): any => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const fetchBranch = axiosClient.post(
        type ? dataConstants.getRegBranchesUrl : dataConstants.getBranchesUrl
      );
      const fetchCrops = axiosClient.post(
        type ? dataConstants.getRegCropUrl : dataConstants.getCropsUrl
      );
      const [branchResponse, cropResponse] = await Promise.all([
        fetchBranch,
        fetchCrops,
      ]);
      const userTerritory: number[] =
        getState().user?.userData?.user_territories;
      const userCrops: number[] = getState().user?.userData?.crops;
      const userActiveBranches = getState().user?.userData?.active_territories;
      const userTerritorybranch: {
        territory_id: number;
        territory_name: string;
      }[] =
        userTerritory &&
        branchResponse.data.data.filter(
          (item: { territory_id: number; territory_name: string }) =>
            userTerritory.includes(item.territory_id)
        );
      const userCropsbranch: {
        crop_id: number;
        crop_name: string;
      }[] =
        userCrops &&
        cropResponse.data.data.filter(
          (item: { crop_id: number; crop_name: string }) =>
            userCrops.includes(item.crop_id)
        );
      const modifiedBranchesArray: { id: number; name: string }[] = reduceArray(
        "territory_id",
        "territory_name",
        !type ? userTerritorybranch : branchResponse.data.data
      );
      const modifiedCropsArray: { id: number; name: string }[] = reduceArray(
        "crop_id",
        "crop_name",
        !type ? userCropsbranch : cropResponse.data.data
      );
      const modifiedCropsUnitArray: { id: number; name: string }[] = reduceArray(
        "crop_id",
        "unit",
        !type ? userCropsbranch : cropResponse.data.data
      );
      let defaultCrops: any;
      let defaultBranch: any;
      if (!type) {
        const fetchParameterUrl = await axiosClient.post(
          dataConstants.getParameterUrl,
          {}
        );
        dispatch(setParameters(fetchParameterUrl.data.data))
        defaultCrops = modifiedCropsArray.filter((item) =>
          fetchParameterUrl.data.data.some(
            (items) =>
              items.parameter_type === "default_crop" &&
              item.id.toString() === items.parameter_data_value.toString()
          )
        );
        defaultBranch = modifiedBranchesArray.filter((items) =>
          userActiveBranches[
            defaultCrops.length > 0
              ? defaultCrops[0].id
              : modifiedCropsArray[0].id
          ].includes(items.id)
        );
        dispatch(setBranches(defaultBranch));
        dispatch(setSelectedBranch(defaultBranch[0].id));
        !type && (await dispatch(fetchHubs(defaultBranch[0].id)));
        await dispatch(
          fetchVarieties(
            defaultCrops[0]?.id ?? modifiedCropsArray[0]?.id,
            defaultBranch[0].id
          )
        );
        const fetchSeason = axiosClient.get(dataConstants.getSeasonUrl);
        const [seasonResponse] = await Promise.all([fetchSeason]);
        dispatch(setSeason(seasonResponse.data.data.filter((item) => item.default_flag == 1)))
      } else {
        dispatch(setBranches(modifiedBranchesArray));
      }

      dispatch(setCrops(modifiedCropsArray));
      dispatch(setCropsUnit(modifiedCropsUnitArray));
      !type &&
        dispatch(
          setSelectedCrop(
            defaultCrops.length > 0
              ? defaultCrops[0].id
              : modifiedCropsArray[0].id
          )
        );
      !type && (await dispatch(fetchBagType()));
      dispatch(setLoading(false));
      return true;
    } catch (error) {
      dispatch(setLoading(false));
      return dispatch(
        setErrorMsg(
          !type
            ? "Branch, Crops and Varieties could not be updated."
            : "Branch & Crop values could not be fetched."
        )
      );
    }
  };
};
export const fetchCropWiseBranch = (cropId): any => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const fetchBranch = axiosClient.post(dataConstants.getBranchesUrl);
      const [branchResponse] = await Promise.all([fetchBranch]);
      const userTerritory: number[] =
        getState().user?.userData?.user_territories;
      const userActiveBranches = getState().user?.userData?.active_territories;
      const userTerritorybranch: {
        territory_id: number;
        territory_name: string;
      }[] =
        userTerritory &&
        branchResponse.data.data.filter(
          (item: { territory_id: number; territory_name: string }) =>
            userTerritory.includes(item.territory_id)
        );
      const modifiedBranchesArray: { id: number; name: string }[] = reduceArray(
        "territory_id",
        "territory_name",
        userTerritorybranch
      );
      let defaultBranch: any;
      defaultBranch = modifiedBranchesArray.filter((items) =>
        userActiveBranches[cropId].includes(items.id)
      );
      dispatch(setBranches(defaultBranch));
      dispatch(setSelectedBranch(defaultBranch[0].id));
      await dispatch(fetchHubs(defaultBranch[0].id));
      dispatch(setLoading(false));
      return true;
    } catch (error) {
      dispatch(setLoading(false));
      return dispatch(setErrorMsg("Branch could not be updated."));
    }
  };
};

export const fetchHubs = (id: number): any => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    await axiosClient
      .post(dataConstants.getHubsUrl, {
        branch_id: id,
      })
      .then((response) => {
        const modifiedHubsArray: { id: number; name: string }[] = reduceArray(
          "territory_id",
          "territory_name",
          response.data.data
        );
        dispatch(setHubs(modifiedHubsArray));
        dispatch(setLoading(false));
      })
      .catch((error) => {
        dispatch(setLoading(false));
        dispatch(setErrorMsg("Latest hubs could not be updated."));
      });
  };
};
export const getFrameData = async () => {
  return await axiosClient
    .get(dataConstants.getIframeData)
    .then((response) => {
      return response.data.data
    })
    .catch((error) => {
      return error
    });
};